angular.module('jv.candidate.details.crm.controller', [])
    .controller('jvCRMController', ['$scope', '$timeout',
    function ($scope, $timeout) {
        let isInitialized = false;
        let isRendered = false;

        $scope.flags.loading = false;

        $scope.init = function () {
            if (isInitialized) {
                return;
            }
            const crmTabContent = document.getElementById('crmTabContent');
            if (!crmTabContent) {
                $timeout($scope.init, 50);
                return;
            }

            if (window.TalemetryMatchPlugin) {
                isInitialized = true;
                $scope.locale = window._jvselfUser?.locale?.languageTag;
                window.matchPluginInstance = window.matchPluginInstance || window.TalemetryMatchPlugin({
                    applicationId: 'jobvite-ats',
                    locale: $scope.locale,
                    themeOptions: { darkMode: false },
                    defaultOptions: { perPageSize: 25 },
                    events: {
                        onUnauthorized: ({
                            authUrl
                        }) => {
                            let serviceUrl = window.location.href;
                            let url = new URL(authUrl);
                            url.searchParams.delete('service');
                            url.searchParams.append('service', serviceUrl);
                            window.location.href = url.toString();
                        }
                    }
                });

                const candidateEId = $scope.appDetails?.application?.candidateEId;
                if (candidateEId && !isRendered) {
                    isRendered = true;
                    const remoteIdWithHash = candidateEId + $scope.hashCodeConvert(candidateEId);
                    window.matchPluginInstance.render.applicantTab(crmTabContent, {
                        remoteId: remoteIdWithHash
                    });
                }
            } else {
                $timeout($scope.init, 50);
            }
        };
        $timeout($scope.init, 0);
    }]);
